import MultiSelectField, {
  MultiSelectFieldProps,
} from 'components/forms/multiSelectField/MultiSelectField';
import { TriggerState } from 'models/automation/Triggers';
import { useTranslation } from 'react-i18next';
import { orderBy } from 'utils/arrayUtils';

interface StatusMultiSelectFieldProps
  extends Omit<MultiSelectFieldProps, 'fieldRenderer' | 'options'> {}

const STATUS_OPTIONS = [TriggerState.CANCELLED, TriggerState.SCHEDULED];

const StatusMultiSelectField = ({ ...props }: StatusMultiSelectFieldProps) => {
  const { t } = useTranslation();
  const actions = STATUS_OPTIONS.map((value) => ({
    label: t('pageAutomations.triggers.triggerState', { context: value }),
    value,
  }));
  const options = orderBy(actions, [{ field: 'label', order: 'asc' }]);

  return (
    <MultiSelectField
      colSmInput={8}
      colSmLabel={4}
      isSelectAllEnabled
      options={options}
      {...props}
    />
  );
};

export default StatusMultiSelectField;
